import Measure from './Measure.vue';
export default Measure;
